import { ShopperAgentTraceMessagesSchema } from "@redotech/redo-shopper-agent-common/trace";
import * as z from "zod";

export const getShopperAgentTraceMessages = {
  name: "getShopperAgentTraceMessages" as const,
  input: z.object({
    channelThreadId: z.string(),
    /** The `next` of the page above; left out for the newest page. */
    before: z.string().optional(),
  }),
  output: ShopperAgentTraceMessagesSchema,
};
